import get from 'lodash/get';

export const getAgencyCode = (siteConfigs: Object): string | undefined =>
  get(siteConfigs, 'brandSiteConfig.partnerConfig.agencyInfo.agencyCode');
